module.exports = __webpack_public_path__ + "img/step2-c.d6d39a72.png";